import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import Store from 'store/store';
import s from 'components/bolt/neonHeader/neonHeader.sss';

export default class NeonHeader extends Component {
	constructor(props) {
		super(props);
		this.state = {
			navMenuOpen: false
		};
		this.toggleNavMenu = this.toggleNavMenu.bind(this);
	}

	toggleNavMenu() {
		this.setState({ navMenuOpen: !this.state.navMenuOpen });
	}

	render() {
		const width = Store.get()?.client?.dimensions?.width;
		const style = {
			transition: 'transform 400ms ease 0s',
			transform: this.state.navMenuOpen ? 'translateY(0px)' : 'translateY(-282px)'
		};
		return (
			<div class={s.navContainer}>
				<div data-collapse="medium" data-animation="default" data-duration="400" data-no-scroll="1" data-easing="ease" data-easing2="ease" role="banner" class={joinClasses(s.navbar1, s.activeNav1, s.wNav)}>
					<div class={s.navWrap}>
						<a href="/" id="w-node-d0544142-1d37-73bd-2dfb-a649e81b0fc8-e81b0fc6" aria-current="page" class={joinClasses(s.brand, s.navBrand, s.wCurrent)} aria-label="home">
							<img src="https://global-uploads.webflow.com/5e95052c09d24e612335a601/5e9f4f17550a7eb0eb8c5a41_neon-logo.svg" height="32" alt="" />
						</a>
						<div class={s.navMenuWrap}>
							{width < 991 && (
								<div class={s.menuButton} style="-webkit-user-select: text;" aria-label="menu" role="button" tabindex="0" aria-controls="w-nav-overlay-0" aria-haspopup="menu" aria-expanded="false">
									<img src="https://global-uploads.webflow.com/5e95052c09d24e612335a601/5eb0396e0a8b570938e01881_menu-black.svg" width="20" alt="" class={s.menuIcon} onClick={this.toggleNavMenu} />
								</div>
							)}
							{width > 991 && (
								<nav role="navigation" class={s.navMenu}>
									<a href="https://neonrated.com/films" target="_blank" class={s.navLink}>FILMS</a>
									<a href="https://shopneonrated.com/" target="_blank" class={s.navLink}>SHOP</a>
									<a href="https://cinema.neonrated.com/" target="_blank" class={s.navLink}>NEON&nbsp;CINEMA</a>
									<a href="https://neonrated.com/sign-up" target="_blank" class={s.navLink}>SIGN UP</a>
								</nav>
							)}
						</div>
					</div>
				</div>
				{width < 991 && (
					<nav role="navigation" class={s.navMenu} style={style}>
						<a href="https://neonrated.com/films" target="_blank" class={s.navLink}>FILMS</a>
						<a href="https://shopneonrated.com/" target="_blank" class={s.navLink}>SHOP</a>
						<a href="https://cinema.neonrated.com/" target="_blank" class={s.navLink}>NEON&nbsp;CINEMA</a>
						<a href="https://neonrated.com/sign-up" target="_blank" class={s.navLink}>SIGN UP</a>
					</nav>
				)}
				<div class={s.wNavOverlay} data-wf-ignore="" id="w-nav-overlay-0" style={this.state.navMenuOpen ? 'height: 52378.8px; display: block;' : 'display: none;'} onClick={this.toggleNavMenu} />
			</div>
		);
	}
}